var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { MediaQuery } from "@riseart/common";
import { raScreenXsMax, raScreenSm, raScreenMdMax, raScreenLg } from "@riseart/antd-provider/dist/website/variables.less";
var SectionEmpty = /* @__PURE__ */ __name(function SectionEmpty2(_ref) {
  var _ref$config = _ref.config, _ref$config2 = _ref$config === void 0 ? {} : _ref$config, small = _ref$config2.small, medium = _ref$config2.medium, large = _ref$config2.large;
  return /* @__PURE__ */ React.createElement(MediaQuery, {
    minWidth: 0
  }, /* @__PURE__ */ React.createElement(MediaQuery, {
    maxWidth: raScreenXsMax
  }, /* @__PURE__ */ React.createElement("div", {
    style: small
  })), /* @__PURE__ */ React.createElement(MediaQuery, {
    minWidth: raScreenSm,
    maxWidth: raScreenMdMax
  }, /* @__PURE__ */ React.createElement("div", {
    style: medium
  })), /* @__PURE__ */ React.createElement(MediaQuery, {
    minWidth: raScreenLg
  }, /* @__PURE__ */ React.createElement("div", {
    style: large
  })));
}, "SectionEmpty");
export {
  SectionEmpty
};
